import Axios from "axios";

export const getReverseGeoCode = async (address) => {
  let result = await Axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyAouz8rFGlw0mzOwrryd4_ZY0ZYSPq-m-o&address=${address}`
  );
  return result;
};
